import { styled } from '@mui/material'
import { CallEnd as CallEndIcon, Call as CallIcon } from '@mui/icons-material'
import { ControlButton } from './control-button'
import { callService } from '$logic/call'
import { t } from '$i18n'

const Container = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 48px;
`

export function IncomingCallControls() {
  return (
    <Container>
      <ControlButton
        color="success"
        caption={t('call.accept')}
        icon={<CallIcon />}
        onClick={callService.acceptIncomingCall}
      />

      <ControlButton
        color="error"
        caption={t('call.reject')}
        icon={<CallEndIcon />}
        onClick={callService.rejectIncomingCall}
      />
    </Container>
  )
}
